import { defineMessages } from 'react-intl';

export const heidi2OnboardingMessages = defineMessages({
  welcomeTitle: {
    defaultMessage: 'Welcome to Heidi II',
    id: '3FjUVfyGnh',
    description: 'Heidi 2.0 onboarding welcome step heading',
  },
  welcomeSeeHowItWorks: {
    defaultMessage: 'See how it works',
    id: 'x1RyqOck4d',
    description:
      'Primary CTA on the Heidi 2.0 onboarding welcome step — advances to the next demo',
  },
  welcomeExploreLater: {
    defaultMessage: 'Explore later',
    id: 'LdFJq2yvoC',
    description:
      'Secondary CTA on the Heidi 2.0 onboarding welcome step — leaves the tour, same as Skip tour',
  },
  welcomeSubtitle: {
    defaultMessage: 'Heidi writes, answers, and <i>now acts</i>.',
    id: 'l9j9lzk9Tu',
    description:
      'Heidi 2.0 onboarding welcome step subtitle. i wraps the italic phrase “now acts”.',
  },
  welcomeLegalBody: {
    defaultMessage:
      'By using Heidi II, you agree to our updated <terms>Terms of Service</terms> and <privacy>privacy policy</privacy>.',
    id: 'MjbGdqyK7t',
    description:
      'Heidi 2.0 onboarding welcome step legal agreement line. terms and privacy wrap the document links.',
  },

  handoffTitle: {
    defaultMessage: 'You can now give tasks to Heidi.',
    id: 'ZJ32QlZQrz',
    description: 'Heidi 2.0 onboarding hand-off step heading',
  },
  handoffSubtitle: {
    defaultMessage: 'You approve everything that needs review.',
    id: 'LKmQ1ibmP9',
    description: 'Heidi 2.0 onboarding hand-off step subtitle',
  },
  handoffDemoRequest: {
    defaultMessage: 'Pre-chart my upcoming patients',
    id: 'kCaRlgi5zi',
    description:
      'Illustrative clinician request shown in the Heidi 2.0 onboarding hand-off demo. Not a real task.',
  },
  handoffDemoReply: {
    defaultMessage: 'Checking your EMR and calendar…',
    id: 'L6zjS9s8LW',
    description: 'Illustrative agent reply in the Heidi 2.0 onboarding hand-off demo',
  },
  handoffDemoPlanCardTitle: {
    defaultMessage: 'Pre-chart plan',
    id: '1kq3ojFgsJ',
    description:
      'Title of the illustrative plan card in the Heidi 2.0 onboarding hand-off demo',
  },
  handoffDemoStepPullAppointments: {
    defaultMessage: 'Pull appointments',
    id: 'm68XARyfvx',
    description: 'Illustrative plan step in the Heidi 2.0 onboarding hand-off demo',
  },
  handoffDemoStepCreateSessions: {
    defaultMessage: 'Create sessions',
    id: 'bgrHhjdlFy',
    description: 'Illustrative plan step in the Heidi 2.0 onboarding hand-off demo',
  },
  handoffDemoStepDraftPrecharts: {
    defaultMessage: 'Draft pre-charts',
    id: '/rPVTXxlwZ',
    description: 'Illustrative plan step in the Heidi 2.0 onboarding hand-off demo',
  },
  handoffDemoAria: {
    defaultMessage: 'Illustration of Heidi working through a three step plan',
    id: 'CAlF5eWbYA',
    description:
      'Accessible label for the non-interactive hand-off demo in Heidi 2.0 onboarding',
  },

  tellHeidiTitle: {
    defaultMessage: 'Tell Heidi what needs doing.',
    id: 'vDYTFS7yjd',
    description: 'Heidi 2.0 onboarding example-task list heading',
  },
  tellHeidiSubtitle: {
    defaultMessage: 'See how it works.',
    id: 'PHNui1+qUj',
    description: 'Heidi 2.0 onboarding example-task list subtitle',
  },
  tellHeidiExamplesAria: {
    defaultMessage: 'Example tasks you can hand to Heidi',
    id: '2Y6oAfuLr0',
    description: 'Accessible label for the Heidi 2.0 onboarding example-task list',
  },

  handlesItTitle: {
    defaultMessage: 'Heidi works through it.',
    id: '75n1vzcIVe',
    description: 'Heidi 2.0 onboarding automated-work demo heading',
  },
  handlesItSubtitle: {
    defaultMessage: 'Here’s an example.',
    id: '/6s9hh+gUo',
    description: 'Heidi 2.0 onboarding automated-work demo subtitle',
  },
  handlesItDoneTitle: {
    defaultMessage: 'Ready for your final approval.',
    id: 'eMKaoON7qV',
    description:
      'Heidi 2.0 onboarding automated-work demo heading, once the demo has finished and its drafts wait on approval',
  },
  handlesItDoneSubtitle: {
    defaultMessage: 'You’re always in control.',
    id: 'HKW2dLMKvf',
    description:
      'Heidi 2.0 onboarding automated-work demo subtitle, once the demo has finished',
  },

  readyTitle: {
    defaultMessage: 'You’re all set! Let’s put Heidi to work.',
    id: 'AFznioiunw',
    description: 'Heidi 2.0 onboarding finale heading',
  },
  readySubtitle: {
    defaultMessage: 'Try it in Home and Scribe.',
    id: '0SJPhrv8kM',
    description: 'Heidi 2.0 onboarding finale subtitle',
  },
  readyGetStarted: {
    defaultMessage: 'Get started',
    id: 'WGo+SxDIiK',
    description: 'Primary CTA on the Heidi 2.0 onboarding finale — leaves the tour',
  },
  readyBookDemo: {
    defaultMessage: 'Book time with an expert',
    id: 'Ri3ujQ6zBB',
    description:
      'Secondary CTA on the Heidi 2.0 onboarding finale — opens the book-a-demo form',
  },

  readyBookDemoAlreadyBooked: {
    defaultMessage: 'You\u2019ve already booked a demo',
    id: 'xHXdaibP3p',
    description:
      'Tooltip on the disabled Heidi 2.0 book-a-demo CTA once the user has booked one',
  },

  bookDemoTitle: {
    defaultMessage: 'Book a demo',
    id: 'h2sBqzltmO',
    description: 'Heading of the Heidi 2.0 book-a-demo modal',
  },
  bookDemoSubtitle: {
    defaultMessage: 'Confirm your details and a Heidi expert will be in touch soon.',
    id: 'Ql62dXr6Bh',
    description: 'Subtitle of the Heidi 2.0 book-a-demo modal',
  },
  bookDemoFirstNameLabel: {
    defaultMessage: 'First name',
    id: 'Zx4TNWi9zl',
    description: 'Label for the first-name field in the Heidi 2.0 book-a-demo modal',
  },
  bookDemoFirstNamePlaceholder: {
    defaultMessage: 'First name',
    id: '02cRKY9DTX',
    description:
      'Placeholder for the first-name field in the Heidi 2.0 book-a-demo modal',
  },
  bookDemoFirstNameRequired: {
    defaultMessage: 'Enter your first name',
    id: 'FZRkJPfyhl',
    description:
      'Validation message when the Heidi 2.0 book-a-demo first-name field is empty',
  },
  bookDemoLastNameLabel: {
    defaultMessage: 'Last name',
    id: 'gJFb90D4It',
    description: 'Label for the last-name field in the Heidi 2.0 book-a-demo modal',
  },
  bookDemoLastNamePlaceholder: {
    defaultMessage: 'Last name',
    id: '//yyj45yQW',
    description: 'Placeholder for the last-name field in the Heidi 2.0 book-a-demo modal',
  },
  bookDemoLastNameRequired: {
    defaultMessage: 'Enter your last name',
    id: 'EWe6OpDwz6',
    description:
      'Validation message when the Heidi 2.0 book-a-demo last-name field is empty',
  },
  bookDemoEmailLabel: {
    defaultMessage: 'Email',
    id: 'EJRzNOat4Z',
    description: 'Label for the email field in the Heidi 2.0 book-a-demo modal',
  },
  bookDemoEmailPlaceholder: {
    defaultMessage: 'name@mail.com',
    id: '5nZIhQoUX8',
    description: 'Placeholder for the email field in the Heidi 2.0 book-a-demo modal',
  },
  bookDemoEmailRequired: {
    defaultMessage: 'Enter your email address',
    id: 'bBvMl2l2c2',
    description: 'Validation message when the Heidi 2.0 book-a-demo email field is empty',
  },
  bookDemoEmailInvalid: {
    defaultMessage: 'Enter a valid email address',
    id: 'pKw1XOewO3',
    description:
      'Validation message when the Heidi 2.0 book-a-demo email field is not an email address',
  },
  bookDemoOrganisationLabel: {
    defaultMessage: 'Organisation',
    id: 'YVn5rpT6i+',
    description: 'Label for the organisation field in the Heidi 2.0 book-a-demo modal',
  },
  bookDemoOrganisationPlaceholder: {
    defaultMessage: 'Organisation',
    id: 'LVzlyxLLqM',
    description:
      'Placeholder for the organisation field in the Heidi 2.0 book-a-demo modal',
  },
  bookDemoOrganisationRequired: {
    defaultMessage: 'Enter your organisation',
    id: '7QhaqAFWDW',
    description:
      'Validation message when the Heidi 2.0 book-a-demo organisation field is empty',
  },
  bookDemoCountryLabel: {
    defaultMessage: 'Country',
    id: 'Kh76R5uZYB',
    description: 'Label for the country field in the Heidi 2.0 book-a-demo modal',
  },
  bookDemoCountryPlaceholder: {
    defaultMessage: 'Country',
    id: 'msGIqKpWgi',
    description: 'Placeholder for the country field in the Heidi 2.0 book-a-demo modal',
  },
  bookDemoCountrySearch: {
    defaultMessage: 'Search countries',
    id: 'XwsnNL/b3S',
    description: 'Search field inside the Heidi 2.0 book-a-demo country picker',
  },
  bookDemoCountryRequired: {
    defaultMessage: 'Select your country',
    id: 'zJDk0WwGvR',
    description:
      'Validation message when the Heidi 2.0 book-a-demo country field is empty',
  },
  bookDemoPhoneLabel: {
    defaultMessage: 'Phone (optional)',
    id: 'Vsew25cIPs',
    description: 'Label for the optional phone field in the Heidi 2.0 book-a-demo modal',
  },
  bookDemoPhonePlaceholder: {
    defaultMessage: 'Phone number',
    id: '1AjMiR7egq',
    description:
      'Placeholder for the optional phone field in the Heidi 2.0 book-a-demo modal',
  },
  bookMeetingPhoneLabel: {
    defaultMessage: 'Phone number',
    id: 'f0+/IrYqyM',
    description:
      'Label for the required phone field on the Heidi 2.0 book-a-meeting details step',
  },
  bookMeetingPhoneRequired: {
    defaultMessage: 'Enter a phone number',
    id: 'MPaV2y74xv',
    description:
      'Validation message when the Heidi 2.0 book-a-meeting phone field is empty',
  },
  bookDemoCancel: {
    defaultMessage: 'Cancel',
    id: 'SbbrHQT7Hu',
    description: 'Dismisses the Heidi 2.0 book-a-demo modal without sending',
  },
  bookDemoSend: {
    defaultMessage: 'Send',
    id: 'IIXb6u3Yxt',
    description: 'Submits the Heidi 2.0 book-a-demo form',
  },
  bookDemoSubmitFailed: {
    defaultMessage: 'We could not send your request. Please try again.',
    id: 'cAxY5sdsCh',
    description: 'Error shown when the Heidi 2.0 book-a-demo request fails to send',
  },
  bookDemoSubmitSuccess: {
    defaultMessage: 'Sent! We’ll be in touch',
    id: 'nEtfVsv/ih',
    description: 'Success toast after the Heidi 2.0 book-a-demo request is sent',
  },
  bookDemoSubmitTimedOut: {
    defaultMessage: 'Request timed out. Please try again.',
    id: 'T9m0bkXA4w',
    description: 'Error toast when the Heidi 2.0 book-a-demo request times out',
  },
  bookMeetingTitle: {
    defaultMessage: 'Book a time',
    id: 'tiq7rY+BOv',
    description: 'Heading of the Heidi 2.0 book-a-demo scheduler while picking a slot',
  },
  bookMeetingSubtitle: {
    defaultMessage: 'Choose a time to speak with a Heidi expert',
    id: 'IXNeFF0tSU',
    description: 'Subtitle of the Heidi 2.0 book-a-demo scheduler while picking a slot',
  },
  bookMeetingDetailsTitle: {
    defaultMessage: 'Confirm your details',
    id: 'KHN0UlbOTM',
    description: 'Heading of the Heidi 2.0 book-a-demo scheduler on the details step',
  },
  bookMeetingDetailsSubtitle: {
    defaultMessage: 'We\u2019ll send the invitation to the email you provide.',
    id: '4khC9+TwLD',
    description: 'Subtitle of the Heidi 2.0 book-a-demo scheduler on the details step',
  },
  bookMeetingLocation: {
    defaultMessage: 'Google Meet',
    id: '185qkSJh/k',
    description: 'Where the Heidi 2.0 booked demo takes place',
  },
  bookMeetingDuration: {
    defaultMessage: '{minutes, plural, one {# min} other {# mins}}',
    id: 'fobrw+2cyn',
    description: 'How long the Heidi 2.0 booked demo runs for',
  },
  bookMeetingTimezoneLabel: {
    defaultMessage: 'Timezone',
    id: 'xm6YGr+CL8',
    description: 'Label for the timezone picker in the Heidi 2.0 book-a-demo scheduler',
  },
  bookMeetingTimezoneSearch: {
    defaultMessage: 'Search timezones',
    id: '6uK1l6gp3q',
    description: 'Search field inside the Heidi 2.0 book-a-demo timezone picker',
  },
  bookMeetingTimezoneEmpty: {
    defaultMessage: 'No timezones found',
    id: 'fiKgTZTVOe',
    description: 'Empty state of the Heidi 2.0 book-a-demo timezone picker',
  },
  bookMeetingStep: {
    defaultMessage: 'Step {step} of {total}',
    id: '0/r5MO0Ld4',
    description: 'Progress marker in the Heidi 2.0 book-a-demo scheduler footer',
  },
  bookMeetingPickDate: {
    defaultMessage: 'Pick a date to see the times that are open',
    id: '6wK13wOOXI',
    description:
      'Shown beside the Heidi 2.0 book-a-demo calendar before a date is chosen',
  },
  bookMeetingNoTimes: {
    defaultMessage: 'No times left on this day',
    id: 'jVrxr7+C1o',
    description: 'Shown when the chosen Heidi 2.0 book-a-demo date has no slots left',
  },
  bookMeetingNoOpenTimes: {
    defaultMessage: 'No times are open right now. Please try again later.',
    id: '9Qoc7PyZhf',
    description: 'Shown when a Heidi 2.0 book-a-demo scheduler has no open slots at all',
  },
  bookMeetingNoTimesInMonth: {
    defaultMessage: 'No times available in {month}',
    id: 'jnNW0N4BJC',
    description:
      'Tooltip on a disabled month arrow in the Heidi 2.0 book-a-demo calendar, naming the month it would move to',
  },
  bookMeetingLoadFailed: {
    defaultMessage: 'We could not load available times. Please try again.',
    id: 'GT90LvuX9S',
    description: 'Error shown when the Heidi 2.0 book-a-demo availability read fails',
  },
  bookMeetingBook: {
    defaultMessage: 'Book',
    id: 'ItSgaPi3EF',
    description: 'Confirms the Heidi 2.0 book-a-demo slot and sends the invitation',
  },
  bookMeetingBookFailed: {
    defaultMessage: 'We could not book that time. Please pick another.',
    id: 'MNr591kdFy',
    description: 'Error toast when the Heidi 2.0 book-a-demo booking is rejected',
  },
  bookMeetingConfirmedTitle: {
    defaultMessage: 'Booking confirmed',
    id: 'BwjQqQIXNA',
    description: 'Heading of the Heidi 2.0 book-a-demo confirmation screen',
  },
  bookMeetingConfirmedWithOrganizer: {
    defaultMessage:
      'You\u2019re booked in with {organizer}. An invitation has been emailed to you.',
    id: 'neKhGX0UOW',
    description:
      'Heidi 2.0 book-a-demo confirmation body when the link names who the meeting is with',
  },
  bookMeetingConfirmedSubtitle: {
    defaultMessage:
      'You\u2019re booked in with a Heidi expert. An invitation has been emailed to you.',
    id: 'coWe2GoGUb',
    description:
      'Heidi 2.0 book-a-demo confirmation body when the link names no one, as round-robin links do',
  },
  bookMeetingClose: {
    defaultMessage: 'Close',
    id: 'AzT+PDIm1f',
    description: 'Dismisses the Heidi 2.0 book-a-demo confirmation screen',
  },
  bookMeetingLoadingAria: {
    defaultMessage: 'Loading available times',
    id: 'Lzvh9VQmfD',
    description:
      'Accessible label for the placeholder shown while Heidi 2.0 book-a-demo times load',
  },

  bookDemoLoadingAria: {
    defaultMessage: 'Loading the book a demo form',
    id: 'RTPnY8gxRG',
    description:
      'Accessible label for the placeholder shown while the Heidi 2.0 book-a-demo form loads',
  },

  continue: {
    defaultMessage: 'Continue',
    id: '5qzX2OXaP0',
    description: 'CTA advancing to the next Heidi 2.0 onboarding step',
  },
  skip: {
    defaultMessage: 'Skip',
    id: 'wjNYRsNdIG',
    description:
      'Ghost CTA under Continue that skips the current demo and advances to the next step or prompt',
  },
  endTour: {
    defaultMessage: 'End tour',
    id: 'Xdp83CcvcZ',
    description: 'Header CTA leaving the Heidi 2.0 onboarding tour',
  },
  skipTour: {
    defaultMessage: 'Skip tour',
    id: 'TD0Mm40z5/',
    description: 'Welcome step CTA skipping the remaining demos for the ready screen',
  },
  back: {
    defaultMessage: 'Back',
    id: '0El9AbUjFh',
    description: 'Header control returning to the previous Heidi 2.0 onboarding step',
  },
  progressAria: {
    defaultMessage: 'Onboarding progress: step {current} of {total}',
    id: 'Fy0glK/cxE',
    description: 'Accessible label for the Heidi 2.0 onboarding progress bar',
  },
});
